export default __webpack_public_path__ + "static/fungames-b57fd633aa1de60e20648a7d3ebfe59e.png";